import { c as _c } from "react/compiler-runtime";
import { Popover as ChakraPopover, Portal } from '@chakra-ui/react';
import { CloseButton } from './close-button';
import { forwardRef } from 'react';
interface PopoverContentProps extends ChakraPopover.ContentProps {
  portalled?: boolean;
  portalRef?: React.RefObject<HTMLElement>;
}
export const PopoverContent = forwardRef<HTMLDivElement, PopoverContentProps>(function PopoverContent(props, ref) {
  const $ = _c(11);
  let portalRef;
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      portalled: t0,
      portalRef,
      ...rest
    } = props);
    $[0] = props;
    $[1] = portalRef;
    $[2] = rest;
    $[3] = t0;
  } else {
    portalRef = $[1];
    rest = $[2];
    t0 = $[3];
  }
  const portalled = t0 === undefined ? true : t0;
  const t1 = !portalled;
  let t2;
  if ($[4] !== ref || $[5] !== rest) {
    t2 = <ChakraPopover.Positioner><ChakraPopover.Content ref={ref} {...rest} /></ChakraPopover.Positioner>;
    $[4] = ref;
    $[5] = rest;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== portalRef || $[8] !== t1 || $[9] !== t2) {
    t3 = <Portal disabled={t1} container={portalRef}>{t2}</Portal>;
    $[7] = portalRef;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
});
export const PopoverArrow = forwardRef<HTMLDivElement, ChakraPopover.ArrowProps>(function PopoverArrow(props, ref) {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ChakraPopover.ArrowTip />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props || $[2] !== ref) {
    t1 = <ChakraPopover.Arrow {...props} ref={ref}>{t0}</ChakraPopover.Arrow>;
    $[1] = props;
    $[2] = ref;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
});
export const PopoverCloseTrigger = forwardRef<HTMLButtonElement, ChakraPopover.CloseTriggerProps>(function PopoverCloseTrigger(props, ref) {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CloseButton size="sm" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props || $[2] !== ref) {
    t1 = <ChakraPopover.CloseTrigger position="absolute" top="1" insetEnd="1" {...props} asChild={true} ref={ref}>{t0}</ChakraPopover.CloseTrigger>;
    $[1] = props;
    $[2] = ref;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
});
export const PopoverTitle = ChakraPopover.Title;
export const PopoverDescription = ChakraPopover.Description;
export const PopoverFooter = ChakraPopover.Footer;
export const PopoverHeader = ChakraPopover.Header;
export const PopoverRoot = ChakraPopover.Root;
export const PopoverBody = ChakraPopover.Body;
export const PopoverTrigger = ChakraPopover.Trigger;